const API_URL = "https://console-shopify.ringbuilder.io/frontend.php";
const STONE_TYPES = ["labgrown", "natural"];
let vdbrcSettingProductGroupId = "";
let isStoneSelected = false;

var vdbrcShapeImages = {
    "Round": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Shape_Round_56b2ba1f-740f-4505-a0bd-41e9985d08ca.png?v=1779737174",
    "Oval": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Shape_Oval_5ed46e08-be2a-4306-a7c5-43063ddbb3f5.png?v=1779737173",
    "Pear": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Shape_Pear_5fbaf9bb-3341-47ea-b43d-ddcaba1584ff.png?v=1779737173",
    "Square Cushion": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Shape_Sq._Cushion.png?v=1779737174",
    "Cushion": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Shape_Long_Cushion.png?v=1779737174",
    "Long Cushion": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Shape_Long_Cushion.png?v=1779737174",
    "Emerald": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Shape_Emerald_68f0cacf-1c2d-48ca-9584-c0cfb65c4e4e.png?v=1779737174",
    "Princess": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Shape_Princess_faa916d4-7203-430e-bbcf-98700ecfbbc2.png?v=1779737173",
    "Marquise": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Shape_Marquise_936a8a9d-51d4-47e5-942e-101109dedc78.png?v=1779737174",
    "Radiant": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Shape_Radiant_a253d47c-c678-44d9-93df-0b1d9ae50204.png?v=1779737173",
    "Asscher": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Shape_Asscher_a8654248-1af0-40b4-9dd1-10cd34490f34.png?v=1779737175",
    "Heart": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Shape_Heart_96cea6f7-aad0-490e-90ca-93c4984efdb5.png?v=1779737174"
};
var vdbrcHeadStyleImages = {
    "Classic Basket": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Heads_Classic_Basket.png?v=1779737175",
    "Classic Bezel": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Heads_Classic_Bezel.png?v=1779737174",
    "Diamond Tulip": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Heads_Diamond_Tulip.png?v=1779737175",
    "Dual Halo": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Heads_Dual_Halo.png?v=1779737175",
    "Fancy Halo": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Heads_Fancy_Halo.png?v=1779737175",
    "Four Prong": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Heads_Four_Prongs.png?v=1779737175",
    "Hidden Halo": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Heads_Hidden_Halo.png?v=1779737174",
    "Lotus Basket": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Heads_Lotus_Basket.png?v=1779737175",
    "Scallopes Six Prongs": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Heads_Scalloped_Six_Prongs.png?v=1779737175",
    "Six Prong": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Heads_Six_Prongs.png?v=1779737175",
    "Six Prong diamond": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Heads_Six_Prong_Diamond.png?v=1779737175",
    "Surprise diamond": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Heads_Surprise_Diamond.png?v=1779737175",
    "Tulip Basket": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Heads_Tulip_Basket.png?v=1779737175",
    "Vintage Basket": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Heads_Vintage_Basket.png?v=1779737173",
    "Diamond Basket BN": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Heads_Diamond_Basket_BN.png?v=1779737174",
    "Classic Halo": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Heads_Classic_Halo.png?v=1779737175"
};
var vdbrcShankStyleImages = {
    "Alternating Marquise": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Shanks_Alternating_Marquise.png?v=1779737175",
    "Baguette Channel": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Shanks_Baguette_Channel.png?v=1779737175",
    "Cathedral Pave": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Shanks_Cathedral_Pave.png?v=1779737175",
    "Channel": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Shanks_Channel_Set.png?v=1779737175",
    "Floating Station": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Shanks_Floating_Station.png?v=1779737175",
    "French Pave": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Shanks_French_Pave.png?v=1779737175",
    "Knife Edge Pave": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Shanks_Knife_Edge_Pave.png?v=1779737175",
    "Knife Edge Solitaire": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Shanks_Knife_Edge_Solitiare.png?v=1779737173",
    "Rope Pave": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Shanks_Rope_Pave.png?v=1779737175",
    "Sleek Accent": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Shanks_Sleek_Accent.png?v=1779737175",
    "Solitaire": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Shanks_Solitiare.png?v=1779737175",
    "Split Ring Solitaire": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Shanks_Split_Ring_Solitiare.png?v=1779737175",
    "Triple Row Pave": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Shanks_Triple_Row_Pave.png?v=1779737174",
    "Twist Pave": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Shanks_Twist_Pave.png?v=1779737174",
    "Alternating Baguette": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Shanks_Alternating_Baguette.png?v=1779737175",
    "Rope Solitiare": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Shanks_Rope_Solitiare.png?v=1779737174"
};
var vdbrcShankMetalImages = {
    "White Gold": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/14f26e77d11b0680ecf04d42b024cc8e943d2466.svg?v=1774374565",
    "Yellow Gold": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Metal_Color_8314132c-681d-4ed4-bab7-2ec5b3698a75.svg?v=1774241440",
    "Rose Gold": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Rose_Metal.svg?v=1775493980",
    "W+Y Gold": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Metal_Color_a0a6f212-86e0-4d0f-97c6-e2bce6b58e4b.svg?v=1774241450",
    "W+R Gold": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/e4c813898dde458a38f2d23e07ec92a81cc271d6.svg?v=1774374630"
};
var vdbrcColorImages = {
    "White Gold": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Metal_Color_35cfc12e-dc12-469c-91b7-f0c00b8724f9.svg?v=1774864726",
    "Yellow Gold": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Metal_Color_8314132c-681d-4ed4-bab7-2ec5b3698a75.svg?v=1774241440",
    "Rose Gold": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Rose_Metal.svg?v=1775493980",
    "W+Y Gold": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Metal_Color_a0a6f212-86e0-4d0f-97c6-e2bce6b58e4b.svg?v=1774241450",
    "W+R Gold": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/e4c813898dde458a38f2d23e07ec92a81cc271d6.svg?v=1774374630",
    "White/Yellow Gold": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/743a18740cc9685854bd9a59f7482903c83372ca.svg?v=1774374795",
    "White/Rose Gold": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/Rose_Metal.svg?v=1775493980",
};
var vdbrcDiamondColorImages = {
    "White": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/icon-white.png",
    "Yellow": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/icon-Yellow.png",
    "Pink": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/icon-Pink.png",
    "Green": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/icon-Green.png",
    "Blue": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/icon-Blue.png",
    "Orange": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/icon-Orange.png",
    "Brown": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/icon-Brown.png",
    "Black": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/32773ab1c0a98b8a7934ca157961f32b4265fef4_bc218fa1-c2ed-46ee-a7c8-fd69d4f7dc04.png?v=1774374844",
    "Other": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/icon-Other.png"
};
var vdbrcRingStyleImages = {
    "Solitaire": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/d305520f04fdaa9ca1dcb463de917c03e75cd00b_4dbfc2ca-9700-40ac-8cfb-04bf6fdb09d1.png?v=1774374437",
    "Pave": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/937031c3d76c62b65fe78a857bd91a0bc6536ae4.png?v=1774374500",
    "Cathedral": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/662939ca7a82fe995c2715f867ba4a269e72bd5b.png?v=1774374530"
}

const canvasId = 'webgl_vdb_canvas';
const three_d_static_data = [
    {
        "pmat": {
            "yellow_gold": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/antique-threed-yellow.pmat",
            "white_gold": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/antique-threed-white.pmat",
            "rose_gold": "https://cdn.shopify.com/s/files/1/0755/7854/0322/files/antique-threed-rose.pmat"
        },
        "dmat": "https://all-demos.s3.us-east-1.amazonaws.com/3D_Assets/Antique-Cut/CADs/diamond-materia.dmat",
        "vjson": "https://all-demos.s3.us-east-1.amazonaws.com/3D_Assets/Antique-Cut/CADs/Antique-Imagesss.vjson",//https://cdn.shopify.com/s/files/1/0755/7854/0322/files/antique-threed-vjson.vjson
    }
];

$(document).ready(async function () {
    await bindSettingData();
});

async function bindSettingData() {
    if (typeof productHandle === 'undefined' || !productHandle) return;

    try {
        var response = await get_setting_info(productHandle);

        if (!response || response.status !== 'success' || !response.data || !response.data.option_data) {
            return;
        }

        // If group id is available in response and not set in Liquid:
        if (!vdbrcSettingProductGroupId && response.group_id) {
            vdbrcSettingProductGroupId = response.group_id;
        }
        let optionData = response.data.option_data;

        renderAllOptionsFromResponse(optionData);

        let product_data = response.data.product_data;
        if (product_data) {
            $('.vdbrc_setting_prod_title').text(product_data.prod_title || '');

            const price = handlePriceData(shop_currency, product_data.price, false);
            const price_without_format = handlePriceData(shop_currency, product_data.price, true);

            $('.vdbrc_setting_prod_price').text(price);
            $('.vdbrc_add_to_cart_btn').attr('data-variant-id', product_data.variant_id || '');
            $('.vdbrc_final_add_to_cart').attr('data-variant-id', product_data.variant_id || '');
            $(".vdbrc_subtotal_price").attr('data-setting-price', price_without_format);

            let stonePrice = $(".vdbrc_subtotal_price").attr('data-stone-price') || 0;
            let settingPrice = $(".vdbrc_subtotal_price").attr('data-setting-price') || 0;
            let subtotalPrice = vdbrcFormatMoney((Number(stonePrice) + Number(settingPrice)) * 100, market_currency_symbol + " {amount}");
            $(".vdbrc_subtotal_price").html(subtotalPrice);

            const images = (product_data?.images && product_data.images != "") ? (product_data.images).split(",") : [];
            if (images.length > 0) {
                const $track = $(".vdbrc_gallery_slider");     // your slider track container
                $track.empty();

                const sliderImageArray = images.slice(1, 11); // We will display 1-10 index images in slider

                if (sliderImageArray.length > 0) {
                    // build slides dynamically
                    sliderImageArray.forEach(function (url, i) {
                        url = (url || "").trim();
                        if (!url) return;

                        $track.append(`
                            <div class="slide ${i === 0 ? "active" : ""}">
                                <img src="${url}" alt="Ring ${i + 1}" class="stonepdp-gallery-image">
                            </div>
                        `);
                    });

                    initSimpleSlider(".simple-slider");
                } else {
                    $(".vdbrc_gallery_slider_container").hide();
                }

                if (images[2] && images[2].trim() != "") {
                    $(".vdbrc_setting_ring_on_hand_image").attr('src', images[2]).show();
                } else {
                    $(".vdbrc_setting_ring_on_hand_image_container").hide();
                }

                if (images[11] && images[11].trim() != "") {
                    $(".vdbrd_setting_hand_view_image").attr('src', images[11]).show();
                } else {
                    $(".vdbrc_setting_hand_view_container").hide();
                }
            }

            const video_url = product_data?.videos || '';
            if (video_url) {
                $(".vdbrc_setting_video").attr('src', video_url).show();
            } else {
                $(".vdbrc_setting_video_container").hide();
            }

            if (product_data?.head_glb && product_data?.shank_glb && product_data?.head_glb !== "" && product_data?.shank_glb !== "") {
                await handleThreeDPart(product_data);
            }else {
                $(".vdbrc_thumb_3d_btn").hide();
            }
        }

        if (optionData.length > 0) {
            var shankStyle = $.grep(optionData, function (item) {
                return item.label === "Shank Style";
            })[0].selected;


            var headStyle = $.grep(optionData, function (item) {
                return item.label === "Head Style";
            })[0].selected;

            $(".vdbrc_setting_shank_style").text(shankStyle);
            $(".vdbrc_setting_head_style").text(headStyle);
        }

    } catch (e) {
        console.error('Failed to load setting data', e);
    }
}

function renderAllOptionsFromResponse(optionData) {
    renderShapeOptions(optionData);
    renderHeadStyleOptions(optionData);
    renderShankStyleOptions(optionData);
    renderMetalOptions(optionData);
    renderColorOptions(optionData);
    renderRingStyleOptions(optionData);
    renderDiamondColorOptions(optionData);
}

function renderShapeOptions(optionData) {
    var wrapper = $('.vdbrc_setting_pdp_option[data-type="Shape"]');
    var container = $('#vdbrc_shape_options_container');

    if (!wrapper.length || !container.length) return;

    var filterOption = null;

    // Find Shape option
    $.each(optionData, function (i, option) {
        if (option.label === 'Shape') {
            filterOption = option;
            return false;
        }
    });

    if (!filterOption || !filterOption.values || !Object.keys(filterOption.values).length) {
        wrapper.hide();
        container.hide();
        return;
    }

    // If found → ensure visible
    wrapper.show();
    container.show();

    // Set selected value in header
    wrapper.find('.vdbrc_selected_option_value').text(`: ${filterOption.selected}`);

    var html = '';
    var index = 0;

    $.each(filterOption.values, function (id, label) {
        var isActive = (label === filterOption.selected);
        var imageUrl = vdbrcShapeImages[label] || Object.values(vdbrcShapeImages)[0];
        var hiddenClass = index >= 4 ? ' vdbrc_shape_hidden' : '';

        html += `
            <div class="option-card vdbrc_shape_card${isActive ? ' selected color-bg-secondary' : ''}${hiddenClass}"
                data-value-id="${id}"
                data-value-label="${label}"
                ${index >= 4 ? 'style="display: none;"' : ''}
            >
                ${imageUrl ? `<img src="${imageUrl}" alt="${label}">` : ''}
              <div class="option-card-text">${label}</div>
            </div>
        `;

        index++;
    });

    /* Show More / Show Less toggle card */
    if (index > 4) {
        html += `
            <div class="variant-option w-94 h-88 p-12 rounded-12 color-bg-primary flex flex-col items-center gap-8 show-more-btn vdbrc_shape_toggle">
                <div class="w-40 h-40 rounded-full color-bg-tertiary flex items-center justify-center">
                    <svg class="plus" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.0002 3.33331V16.6666M16.6668 9.99998H3.3335" stroke="#141B34" stroke-width="1.25" stroke-linejoin="round"/>
                    </svg>
                    <svg class="minus" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" style="display: none;">
                        <path d="M16.6668 10H3.3335" stroke="#141B34" stroke-width="1.25" stroke-linejoin="round"/>
                    </svg>
                </div>
                <span class="text-12 leading-12 color-text-quaternary spdp-show-label">Show More</span>
            </div>
        `;
    }

    container.html(html);
}
$('body').on('click', '#vdbrc_shape_options_container .vdbrc_shape_card', async function () {
    var clicked = $(this);
    var label = clicked.data('value-label');

    $('#vdbrc_shape_options_container .vdbrc_shape_card').removeClass('active');
    clicked.addClass('active');

    $('.vdbrc_setting_pdp_option[data-type="Shape"] .vdbrc_selected_option_value').text(': ' + label);

    await vdbrcRefreshSubOptions();
});
$('body').on('click', '#vdbrc_shape_options_container .vdbrc_shape_toggle', function () {
    var container = $('#vdbrc_shape_options_container');
    var hiddenItems = container.find('.vdbrc_shape_hidden');
    var label = $(this).find('.spdp-show-label');
    var plusIcon = $(this).find('.plus');
    var minusIcon = $(this).find('.minus');

    if (hiddenItems.is(':visible')) {
        hiddenItems.hide();
        label.text('Show More');
        plusIcon.show();
        minusIcon.hide();
    } else {
        hiddenItems.show();
        label.text('Show Less');
        plusIcon.hide();
        minusIcon.show();
    }
});

function renderHeadStyleOptions(optionData) {
    var wrapper = $('.vdbrc_setting_pdp_option[data-type="Head Style"]');
    var container = $('#vdbrc_head_style_container');

    if (!wrapper.length || !container.length) return;

    var filterOption = null;

    // Find Head Style option
    $.each(optionData, function (i, option) {
        if (option.label === 'Head Style') {
            filterOption = option;
            return false;
        }
    });

    if (!filterOption || !filterOption.values || !Object.keys(filterOption.values).length) {
        wrapper.hide();
        container.hide();
        $(".vdbrc_head_section_header").hide();
        return;
    }

    // If found → ensure visible
    wrapper.show();
    container.show();

    // Set selected value
    wrapper.find('.vdbrc_selected_option_value').text(`: ${filterOption.selected}`);

    var html = '';

    $.each(filterOption.values, function (id, label) {
        var isActive = (label === filterOption.selected);
        var imageUrl = vdbrcHeadStyleImages[label] || Object.values(vdbrcHeadStyleImages)[0];

        html += `
            <div class="style-card vdbrc_head_style_card${isActive ? ' selected color-bg-secondary' : ''}"
                data-value-id="${id}"
                data-value-label="${label}"
            >
                ${imageUrl ? `<img src="${imageUrl}" class="style-card-image" alt="${label}">` : ''}
                <div class="style-card-text">${label}</div>
            </div>
        `;
    });

    container.html(html);
}
$('body').on('click', '#vdbrc_head_style_container .vdbrc_head_style_card', async function () {
    var clicked = $(this);
    var label = clicked.data('value-label');

    $('#vdbrc_head_style_container .vdbrc_head_style_card').removeClass('active');
    clicked.addClass('active');

    $('.vdbrc_setting_pdp_option[data-type="Head Style"] .vdbrc_selected_option_value').text(`: ${label}`);

    await vdbrcRefreshSubOptions();
});

function renderShankStyleOptions(optionData) {
    var wrapper = $('.vdbrc_setting_pdp_option[data-type="Shank Style"]');
    var container = $('#vdbrc_shank_style_container');

    if (!wrapper.length || !container.length) return;

    var filterOption = null;

    // Find Shank Style option
    $.each(optionData, function (i, option) {
        if (option.label === 'Shank Style') {
            filterOption = option;
            return false;
        }
    });

    if (!filterOption || !filterOption.values || !Object.keys(filterOption.values).length) {
        wrapper.hide();
        container.hide();
        $(".vdbrc_shank_section_header").hide();
        return;
    }

    // If found → ensure visible
    wrapper.show();
    container.show();

    // Set selected value
    wrapper.find('.vdbrc_selected_option_value').text(`: ${filterOption.selected}`);

    var html = '';

    $.each(filterOption.values, function (id, label) {
        var isActive = (label === filterOption.selected);
        var imageUrl = vdbrcShankStyleImages[label] || Object.values(vdbrcShankStyleImages)[0];

        html += `
            <div class="shank-card shank-card-selected rounded-[12px] p-[12px] flex flex-col items-center justify-between min-w-[80px] w-[94px] vdbrc_shank_style_card${isActive ? ' selected color-bg-secondary' : ''}"
                data-value-id="${id}"
                data-value-label="${label}"
            >
                <div class="w-[40px] h-[40px] mb-[8px]">
                    <div class="w-full h-full bg-gray-200 rounded">
                        ${imageUrl ? `<img src="${imageUrl}" alt="${label}">` : ''}
                    </div>
                </div>
                <span class="shank-text-primary text-[12px] font-normal leading-[12px] text-center">${label}</span>
            </div>
        `;
    });

    container.html(html);
}
$('body').on('click', '#vdbrc_shank_style_container .vdbrc_shank_style_card', async function () {
    var clicked = $(this);
    var label = clicked.data('value-label');

    $('#vdbrc_shank_style_container .vdbrc_shank_style_card').removeClass('active');
    clicked.addClass('active');

    $('.vdbrc_setting_pdp_option[data-type="Shank Style"] .vdbrc_selected_option_value').text(`: ${label}`);

    await vdbrcRefreshSubOptions();
});

function renderMetalOptions(optionData) {
    var wrapper = $('.vdbrc_setting_pdp_option[data-type="Metal"]');
    var container = $('#vdbrc_metal_options_container');

    if (!wrapper.length || !container.length) return;

    var filterOption = null;

    // Find Shank Style option
    $.each(optionData, function (i, option) {
        if (option.label === 'Metal') {
            filterOption = option;
            return false;
        }
    });

    if (!filterOption || !filterOption.values || !Object.keys(filterOption.values).length) {
        wrapper.hide();
        container.hide();
        return;
    };

    // If found → ensure visible
    wrapper.show();
    container.show();


    // Set selected value
    wrapper.find('.vdbrc_selected_option_value').text(`: ${filterOption.selected}`);

    var html = '';

    $.each(filterOption.values, function (id, label) {
        var isActive = (label === filterOption.selected);

        html += `
            <div class="metal-option vdbrc_metal_card${isActive ? ' selected' : ''}
                data-value-id="${id}"
                data-value-label="${label}"
            >${label}</div>
        `;
    });

    container.html(html);
}
$('body').on('click', '#vdbrc_metal_options_container .vdbrc_metal_card', async function () {
    var clicked = $(this);
    var label = clicked.data('value-label');

    $('#vdbrc_metal_options_container .vdbrc_metal_card').removeClass('selected');
    clicked.addClass('selected');

    $('.vdbrc_setting_pdp_option[data-type="Metal"] .vdbrc_selected_option_value').text(`: ${label}`);

    await vdbrcRefreshSubOptions();
});

function renderColorOptions(optionData) {
    var wrapper = $('.vdbrc_setting_pdp_option[data-type="Color"]');
    var container = $('#vdbrc_color_options_container');

    if (!wrapper.length || !container.length) return;

    var filterOption = null;

    // Find Color option
    $.each(optionData, function (i, option) {
        if (option.label === 'Color') {
            filterOption = option;
            return false;
        }
    });

    if (!filterOption || !filterOption.values || !Object.keys(filterOption.values).length) {
        wrapper.hide();
        container.hide();
        return;
    }

    // If found → ensure visible
    wrapper.show();
    container.show();

    // Set selected value
    wrapper.find('.vdbrc_selected_option_value').text(`: ${filterOption.selected}`);

    var html = '';

    $.each(filterOption.values, function (id, label) {
        var isActive = (label === filterOption.selected);
        var imageUrl = vdbrcColorImages[label] || Object.values(vdbrcColorImages)[0];

        html += `
            <div class="option-card vdbrc_color_card${isActive ? ' selected color-bg-secondary' : ''}
                data-value-id="${id}"
                data-value-label="${label}"
            >
                <div class="option-card" style="margin: 0 auto 8px;">
                    ${imageUrl ? `<img src="${imageUrl}" class="w-40 h-40 mix-blend-multiply object-cover" alt="${label}">` : ''}
                </div>
                <div class="option-card-text">${label}</div>
            </div>
        `;
    });

    container.html(html);
}
$('body').on('click', '#vdbrc_color_options_container .vdbrc_color_card', async function () {
    var clicked = $(this);
    var label = clicked.data('value-label');

    $('#vdbrc_color_options_container .vdbrc_color_card').removeClass('selected');
    clicked.addClass('selected');

    $('.vdbrc_setting_pdp_option[data-type="Color"] .vdbrc_selected_option_value').text(`: ${label}`);

    await vdbrcRefreshSubOptions();
});

function renderRingStyleOptions(optionData) {
    var wrapper = $('.vdbrc_setting_pdp_option[data-type="Style"]');
    var container = $('#vdbrc_ring_style_options_container');

    if (!wrapper.length || !container.length) return;

    var filterOption = null;

    // Find Ring Style option
    $.each(optionData, function (i, option) {
        if (option.label === 'Style') {
            filterOption = option;
            return false;
        }
    });

    if (!filterOption || !filterOption.values || !Object.keys(filterOption.values).length) {
        wrapper.hide();
        container.hide();
        return;
    };

    // If found → ensure visible
    wrapper.show();
    container.show();

    // Set selected value
    wrapper.find('.vdbrc_selected_option_value').text(`: ${filterOption.selected}`);

    var html = '';

    $.each(filterOption.values, function (id, label) {
        var isActive = (label === filterOption.selected);
        var imageUrl = vdbrcRingStyleImages[label] || Object.values(vdbrcRingStyleImages)[0];

        html += `
            <div class="option-card vdbrc_ring_style_card${isActive ? ' selected' : ''}"
                data-value-id="${id}"
                data-value-label="${label}"
            >
                ${imageUrl ? `<img src="${imageUrl}" class="w-40 h-40 mix-blend-multiply object-cover" alt="${label}">` : ''}
                <div class="option-card-text ">${label}</div>
            </div>
        `;
    });

    container.html(html);
}
$('body').on('click', '#vdbrc_ring_style_options_container .vdbrc_ring_style_card', async function () {
    var clicked = $(this);
    var label = clicked.data('value-label');

    $('#vdbrc_ring_style_options_container .vdbrc_ring_style_card').removeClass('selected');
    clicked.addClass('selected');

    $('.vdbrc_setting_pdp_option[data-type="Style"] .vdbrc_selected_option_value').text(`: ${label}`);

    await vdbrcRefreshSubOptions();
});

function renderDiamondColorOptions(optionData) {
    var wrapper = $('.vdbrc_setting_pdp_option[data-type="Diamond Color"]');
    var container = $('#vdbrc_diamond_color_options_container');

    if (!wrapper.length || !container.length) return;

    var filterOption = null;

    // Find Shape option
    $.each(optionData, function (i, option) {
        if (option.label === 'Diamond Color') {
            filterOption = option;
            return false;
        }
    });

    if (!filterOption || !filterOption.values || !Object.keys(filterOption.values).length) {
        wrapper.hide();
        container.hide();
        return;
    }

    // If found → ensure visible
    wrapper.show();
    container.show();

    // Set selected value in header
    wrapper.find('.vdbrc_selected_option_value').text(`: ${filterOption.selected}`);

    var html = '';
    var index = 0;

    $.each(filterOption.values, function (id, label) {
        var isActive = (label === filterOption.selected);
        var imageUrl = vdbrcDiamondColorImages[label] || Object.values(vdbrcDiamondColorImages)[0];
        var hiddenClass = index >= 4 ? ' vdbrc_diamond_color_hidden' : '';

        html += `
            <div class="option-card vdbrc_diamond_color_card${isActive ? ' selected color-bg-secondary' : ''}${hiddenClass}"
                data-value-id="${id}"
                data-value-label="${label}"
                ${index >= 4 ? 'style="display: none;"' : ''}
            >
                ${imageUrl ? `<img src="${imageUrl}" alt="${label}">` : ''}
              <div class="option-card-text">${label}</div>
            </div>
        `;

        index++;
    });

    /* Show More / Show Less toggle card */
    if (index > 4) {
        html += `
            <div class="variant-option w-94 h-88 p-12 rounded-12 color-bg-primary flex flex-col items-center gap-8 show-more-btn vdbrc_shape_toggle">
                <div class="w-40 h-40 rounded-full color-bg-tertiary flex items-center justify-center">
                    <svg class="plus" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.0002 3.33331V16.6666M16.6668 9.99998H3.3335" stroke="#141B34" stroke-width="1.25" stroke-linejoin="round"/>
                    </svg>
                    <svg class="minus" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M16.6668 10H3.3335" stroke="#141B34" stroke-width="1.25" stroke-linejoin="round"/>
                    </svg>
                </div>
                <span class="text-12 leading-12 color-text-quaternary spdp-show-label">Show More</span>
            </div>
        `;
    }

    container.html(html);
}
$('body').on('click', '#vdbrc_diamond_color_options_container .vdbrc_diamond_color_card', async function () {
    var clicked = $(this);
    var label = clicked.data('value-label');

    $('#vdbrc_diamond_color_options_container .vdbrc_diamond_color_card').removeClass('selected');
    clicked.addClass('selected');

    $('.vdbrc_setting_pdp_option[data-type="Diamond Color"] .vdbrc_selected_option_value').text(': ' + label);

    await vdbrcRefreshSubOptions();
});
$('body').on('click', '#vdbrc_diamond_color_options_container .vdbrc_diamond_color_toggle', function () {
    var container = $('#vdbrc_diamond_color_options_container');
    var hiddenItems = container.find('.vdbrc_diamond_color_hidden');
    var label = $(this).find('.spdp-show-label');
    var plusIcon = $(this).find('.plus');
    var minusIcon = $(this).find('.minus');

    if (hiddenItems.is(':visible')) {
        hiddenItems.hide();
        label.text('Show More');
        plusIcon.show();
        minusIcon.hide();
    } else {
        hiddenItems.show();
        label.text('Show Less');
        plusIcon.hide();
        minusIcon.show();
    }
});

async function get_setting_info(productHandle) {
    if (!productHandle) {
        console.error("Product handle is required");
        return null;
    }

    const sendData = new URLSearchParams();
    sendData.append("action", "fetch_product_options");
    sendData.append("shop", shop);
    sendData.append("handle", productHandle);

    try {
        const responseData = await new Promise((resolve, reject) => {
            $.post(API_URL, sendData.toString(), (resultData) => {
                try {
                    const parsed = JSON.parse(resultData);
                    resolve(parsed);
                } catch (e) {
                    reject("Invalid JSON response: " + e);
                }
            }).fail((error) => reject(error));
        });

        return responseData;

    } catch (error) {
        console.error("Error loading stones:", error);
        return null;
    }
}

async function get_sub_options(groupId, attributeInfo) {
    if (!groupId) return null;

    var sendData = new URLSearchParams();
    sendData.append("action", "fetch_sub_options_v2");
    sendData.append("shop", shop);
    sendData.append("group_id", groupId);
    sendData.append("attribute_info", JSON.stringify(attributeInfo));

    try {
        var responseData = await new Promise((resolve, reject) => {
            $.post(API_URL, sendData.toString(), (resultData) => {
                try {
                    var parsed = JSON.parse(resultData);
                    resolve(parsed);
                } catch (e) {
                    reject("Invalid JSON response: " + e);
                }
            }).fail((error) => reject(error));
        });

        return responseData;
    } catch (error) {
        console.error("Error loading sub options:", error);
        return null;
    }
}

function vdbrcGetAttributeInfoFromUI(isAtc = false) {
    let result = {};

    $(".vdbrc_setting_pdp_option").each(function () {
        const type = $(this).data("type"); // e.g., "Shape", "Head Style"
        const text = $(this).find(".vdbrc_selected_option_value").text() || "";
        const cleaned = $.trim(text.replace(":", ""));

        if (cleaned !== "") {
            result[type] = cleaned;
        }
    });

    if (isAtc) {
        // Ring size (hidden input)
        const ringSize = $.trim($('input[name="ring_size"]').val() || "");
        if (ringSize !== "") {
            result["Ring Size"] = ringSize;
        }

        const engravingText = $(".vdbrc_engaving_details").data("engraving-text") || "";
        if (engravingText !== "") {
            result["Engraving Text"] = engravingText;
        }
        const engravingFont = $(".vdbrc_engaving_details").data("engraving-font") || "";
        if (engravingFont !== "") {
            result["Engraving Font"] = engravingFont;
        }

    }

    return result;
}

var vdbrcRequestSeq = 0;
async function vdbrcRefreshSubOptions() {
    vdbrcRequestSeq += 1;
    var currentSeq = vdbrcRequestSeq;

    var attributeInfo = vdbrcGetAttributeInfoFromUI();
    var response = await get_sub_options(vdbrcSettingProductGroupId, attributeInfo);

    if (!response || response.status !== 'success' || !response.data || !response.data.option_data) return;

    // Avoid race condition if multiple clicks happen fast
    if (currentSeq !== vdbrcRequestSeq) return;

    let optionData = response.data.option_data;

    renderAllOptionsFromResponse(optionData);

    // Replace handle in url without reloading the page 
    if (response.data.pro_handle) {
        var newUrl = window.location.protocol + "//" + window.location.host + "/products/" + response.data.pro_handle;
        window.history.replaceState({ path: newUrl }, '', newUrl);
    }

    let product_data = response.data.product_data;

    if (product_data) {
        $('.vdbrc_setting_prod_title').text(product_data.prod_title || '');

        const price = handlePriceData(shop_currency, product_data.price, false);
        const price_without_format = handlePriceData(shop_currency, product_data.price, true);

        $('.vdbrc_setting_prod_price').text(price);
        $('.vdbrc_setting_prod_description').html(product_data.description || '');
        $('.vdbrc_add_to_cart_btn').attr('data-variant-id', product_data.variant_id || '');
        $('.vdbrc_final_add_to_cart').attr('data-variant-id', product_data.variant_id || '');
        $(".vdbrc_subtotal_price").attr('data-setting-price', price_without_format);

        let stonePrice = $(".vdbrc_subtotal_price").attr('data-stone-price') || 0;
        let settingPrice = $(".vdbrc_subtotal_price").attr('data-setting-price') || 0;
        let subtotalPrice = vdbrcFormatMoney((Number(stonePrice) + Number(settingPrice)) * 100, market_currency_symbol + " {amount}");
        $(".vdbrc_subtotal_price").html(subtotalPrice);

        const images = (product_data?.images && product_data.images != "") ? (product_data.images).split(",") : [];
        if (images.length > 0) {
            const $track = $(".vdbrc_gallery_slider");     // your slider track container
            $track.empty();

            const sliderImageArray = images.slice(1, 11); // We will display 1-10 index images in slider

            if (sliderImageArray.length > 0) {
                // build slides dynamically
                sliderImageArray.forEach(function (url, i) {
                    url = (url || "").trim();
                    if (!url) return;

                    $track.append(`
                            <div class="slide ${i === 0 ? "active" : ""}">
                                <img src="${url}" alt="Ring ${i + 1}" class="stonepdp-gallery-image">
                            </div>
                        `);
                });

                initSimpleSlider(".simple-slider");
            } else {
                $(".vdbrc_gallery_slider_container").hide();
            }

            if (images[2] && images[2].trim() != "") {
                $(".vdbrc_setting_ring_on_hand_image").attr('src', images[2]).show();
            } else {
                $(".vdbrc_setting_ring_on_hand_image_container").hide();
            }

            if (images[11] && images[11].trim() != "") {
                $(".vdbrd_setting_hand_view_image").attr('src', images[11]).show();
            } else {
                $(".vdbrc_setting_hand_view_container").hide();
            }
        }

        const video_url = product_data?.videos || '';
        if (video_url) {
            $(".vdbrc_setting_video").attr('src', video_url).show();
        } else {
            $(".vdbrc_setting_video_container").hide();
        }

        if (product_data?.head_glb && product_data?.shank_glb && product_data?.head_glb !== "" && product_data?.shank_glb !== "") {
            await handleThreeDPart(product_data,true);
        }else {
            $(".vdbrc_thumb_3d_btn").hide();
        }
    }

    if (optionData && optionData.length > 0) {
        var shankItem = optionData.find(function (item) {
            return item.label === "Shank Style";
        });

        var headItem = optionData.find(function (item) {
            return item.label === "Head Style";
        });

        var shankStyle = shankItem ? shankItem.selected : "";
        var headStyle = headItem ? headItem.selected : "";

        if (shankItem) {
            $(".vdbrc_setting_shank_style").text(shankStyle);
        }

        if (headItem) {
            $(".vdbrc_setting_head_style").text(headStyle);
        }
    }
}


$('body').on('click', '.vdbrc_add_to_cart_btn', async function () {
    const _this = this;
    const variantId = $(this).data('variant-id');

    const ringSize = $.trim($('input[name="ring_size"]').val() || "");
    if (ringSize === "") {
        alert("Please select a ring size before proceeding to cart.");
        return;
    }
    
    const props = vdbrcGetAttributeInfoFromUI(true);
    try {
        await shopifyAddToCart(variantId, 1, props);
        if (isRedirectToCartPage) {
            window.location.href = '/cart';
        } else {
            await vdbrcOpenUpdatedCartDrawer();
        }
    } catch (error) {
        console.error('Error while adding to cart:', error);
        alert(error.message || 'Something went wrong while adding to cart.');
    }
});
async function shopifyAddToCart(variantId, qty = 1, properties = null) {
    const payload = {
        id: Number(variantId),
        quantity: qty
    };

    // Optional: line item properties (shows under item in cart)
    if (properties && typeof properties === "object") {
        payload.properties = properties;
    }

    const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify(payload)
    });

    // Shopify returns 200 + JSON on success, 4xx + JSON on error
    const data = await res.json().catch(() => null);

    if (!res.ok) {
        const msg = (data && (data.description || data.message)) || 'Shopify cart add failed';
        throw new Error(msg);
    }

    return data; // contains added line item object
}

//#region : General Functions
function formatValue(value, defaultValue = "") {
    return value ?? defaultValue;
}
function formatSize(size) {
    return size ? Number(size).toFixed(2) : "";
}
function handlePriceData(stoneCurrencyCode, total_sales_price, withoutFormate = false) {
    // Helper function to check if a value is defined and not empty
    function isValidCurrency(currency) {
        return currency !== undefined && currency !== null && currency !== "";
    }
    // Initial price conversion to shop currency
    let price = Math.round(price_in_shop_currency(total_sales_price));
    if (isValidCurrency(stoneCurrencyCode) && stoneCurrencyCode !== "USD") {
        if (stoneCurrencyCode !== shop_currency) {
            // Convert to USD first, then to shop currency
            let usd_price = parseFloat(currency_conversion(total_sales_price, stoneCurrencyCode, "USD"));
            price = Math.round(price_in_shop_currency(usd_price));
        } else {
            price = Math.round(total_sales_price);
        }
    }
    if (withoutFormate) {
        price = Math.round(total_sales_price);
    } else {
        price = vdbrcFormatMoney(price * 100, moneyFormat);
    }
    // Convert price to market currency if different from shop currency
    if (market_currency !== shop_currency) {
        price = Math.round(price_in_market_currency(total_sales_price));
        if (isValidCurrency(stoneCurrencyCode) && stoneCurrencyCode !== "USD") {
            if (stoneCurrencyCode !== market_currency) {
                // Convert to USD first, then to market currency
                let usd_price = parseFloat(currency_conversion(total_sales_price, stoneCurrencyCode, "USD"));
                price = Math.round(price_in_market_currency(usd_price));
            } else {
                price = Math.round(total_sales_price);
            }
        }
        if (withoutFormate) {
            price = Math.round(price);
        } else {
            price = vdbrcFormatMoney(price * 100, market_currency_symbol + " {amount}");
        }
    }
    return price;
}
function debounce(func, wait) {
    let timeout;
    return function (...args) {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), wait);
    };
}
function isMobileDevice() {
    return /Mobi|Android|iPhone|iPad|iPod|Windows Phone/i.test(navigator.userAgent);
}
function updateUrl(url, key, value) {
    if (value !== undefined) {
        value = encodeURI(value);
    }
    var hashIndex = url.indexOf("#") | 0;
    if (hashIndex === -1) hashIndex = url.length | 0;
    var urls = url.substring(0, hashIndex).split("?");
    var baseUrl = urls[0];
    var parameters = "";
    var outPara = {};
    if (urls.length > 1) {
        parameters = urls[1];
    }
    if (parameters !== "") {
        parameters = parameters.split("&");
        for (k in parameters) {
            var keyVal = parameters[k];
            keyVal = keyVal.split("=");
            var ekey = keyVal[0];
            var evalue = "";
            if (keyVal.length > 1) {
                evalue = keyVal[1];
            }
            outPara[ekey] = evalue;
        }
    }
    if (value !== undefined) {
        outPara[key] = value;
    } else {
        delete outPara[key];
    }
    parameters = [];
    for (var k in outPara) {
        parameters.push(k + "=" + outPara[k]);
    }
    var finalUrl = baseUrl;
    if (parameters.length > 0) {
        finalUrl += "?" + parameters.join("&");
    }
    return finalUrl + url.substring(hashIndex);
}
function resetDeepLink(keepParams = []) {
    const url = new URL(window.top.location.href);
    const searchParams = new URLSearchParams(url.search);

    // Remove everything except allowed params
    for (const key of Array.from(searchParams.keys())) {
        if (!keepParams.includes(key)) {
            searchParams.delete(key);
        }
    }

    const newQuery = searchParams.toString();
    const newUrl = url.pathname + (newQuery ? `?${newQuery}` : '') + url.hash;

    window.top.history.pushState({}, '', newUrl);
}
function removeURLParameters(url, ...parameters) {
    const parsed = new URL(url);
    parameters.forEach(e => parsed.searchParams.delete(e))
    return parsed.toString()
}
//#endregion

$('body').on('click', '#vdbrc_carat_options_container .spdp-carat-option', function () {
    const imageUrl = $(this).data("image");
    const caratValue = $(this).data("carat");

    // Change product image
    $(".vdbrc_setting_carat_hand_image").attr("src", imageUrl);

    // Active class handling
    $(".spdp-carat-option").removeClass("active");

    $(".vdbrc_setting_carat_image_tag_text").text(`Shown in ${caratValue} Ct`);

    // Set selected value in header
    $('.vdbrc_setting_pdp_option[data-type="Carat Size"]').find('.vdbrc_selected_option_value').text(`: ${caratValue} Carat`);

    $(this).addClass("active");
});

$('body').on('click', '.setting_pdp_toggle_btn', function () {
    const button = $(this);
    const type = $(this).data('type');
    const speed = 300;

    // Rotate the icon (assumes an <img> inside the button)
    button.find('img').toggleClass('is-rotated');

    const toggleMap = {
        diamond_setting: ['Shape', 'Carat Size'],
        head_setting: ['Head Style'],
        shank_setting: ['Shank Style', 'Metal', 'Color', 'Diamond Color', 'Band']
    };

    const optionTypes = toggleMap[type];
    if (!optionTypes) return;

    optionTypes.forEach(optionType => {
        $(`.vdbrc_setting_pdp_option[data-type="${optionType}"]`).stop(true, true).fadeToggle(speed);
    });
});

$('body').on('click', '.vdbrc_thumb_3d_btn', function () {
    $(".vdbrc_setting_prod_image").hide();
    $(".vdbrc_video_wrapper").hide();
    $("#webgl_vdb_canvas").show();
    $("#webgl_vdb_canvas").removeClass('d-none');
});
$('body').on('click', '.vdbrc_thumb_image_btn', function () {
    $("#webgl_vdb_canvas").hide();
    $(".vdbrc_video_wrapper").hide();
    $(".vdbrc_setting_prod_image").show();
    $(".vdbrc_setting_prod_image").removeClass('d-none');
});
$('body').on('click', '.vdbrc_thumb_video_btn', function () {
    $(".vdbrc_setting_prod_image").hide();
    $("#webgl_vdb_canvas").hide();
    $(".vdbrc_video_wrapper").show();
    $(".vdbrc_video_wrapper").removeClass('d-none');
});

//#region : ThreeD Functions
async function handleThreeDPart(productData, isUpdate = false) {
    if (Object.keys(productData).length > 0) {
        const headUrl = productData?.head_glb;
        const shankUrl = productData?.shank_glb;

        function readValue(type) {
            var text = $(`.vdbrc_setting_pdp_option[data-type="${type}"] .vdbrc_selected_option_value`).text() || '';
            return $.trim(text.replace(':', ''));
        }

        let selectedMetalColorVal = readValue("Color");
        selectedMetalColorVal = selectedMetalColorVal.toLowerCase();

        let metalHeadColor = 'white_gold';
        let metalShankColor = 'white_gold';
        if (selectedMetalColorVal.includes('rose')) {
            metalHeadColor = 'rose_gold';
            metalShankColor = 'rose_gold';
        } else if (selectedMetalColorVal.includes('yellow')) {
            metalHeadColor = 'yellow_gold';
            metalShankColor = 'yellow_gold';
        } else if (selectedMetalColorVal.includes('W+Y Gold')) {
            metalHeadColor = 'white_gold';
            metalShankColor = 'yellow_gold';
        } else if (selectedMetalColorVal.includes('W+R Gold')) {
            metalHeadColor = 'white_gold';
            metalShankColor = 'rose_gold';
        } else if (selectedMetalColorVal.includes('White/Yellow Gold')) {
            metalHeadColor = 'white_gold';
            metalShankColor = 'yellow_gold';
        } else if (selectedMetalColorVal.includes('White/Yellow Gold')) {
            metalHeadColor = 'white_gold';
            metalShankColor = 'yellow_gold';
        } else if (selectedMetalColorVal.includes('White/Rose Gold')) {
            metalHeadColor = 'white_gold';
            metalShankColor = 'rose_gold';
        }

        const metalHead = three_d_static_data[0]['pmat'][metalHeadColor];
        const metalShank = three_d_static_data[0]['pmat'][metalShankColor];

        const dmatFile = three_d_static_data[0]['dmat'];

        let three_d_media_arr = generateThreeDMediaArray(headUrl, shankUrl, metalHead, metalShank, dmatFile);
        if (three_d_media_arr.length > 0) {
            if (isUpdate) {
                window.player.update(canvasId, three_d_media_arr);
            } else {
                window.player.init(canvasId, three_d_media_arr);
            }
        }
    }
}
function generateThreeDMediaArray(head, shank, metal_head, metal_shank, dmat) {
    let three_d_media = [
        {
            "option_type": "model",
            "option_value": head,
            "option_identifier": "head"
        },
        {
            "option_type": "model",
            "option_value": shank,
            "option_identifier": "shank"
        },
        {
            "option_type": "material",
            "option_value": metal_head,
            "option_identifier": "metal-top,metal- top,Metal 02,Metal 04,head,EW"
        },
        {
            "option_type": "material",
            "option_value": metal_shank,
            "option_identifier": "metal-shank,metal-shape,shank"
        },
        {
            "option_type": "material",
            "option_value": dmat,
            "option_identifier": "mainstone- marquise, mainstone-RADIANT, mainstone-asscher, mainstone-cushion, mainstone-emerald, mainstone-heart, mainstone-long cushion , mainstone-marquise, mainstone-oval, mainstone-ovel, mainstone-pear, mainstone-princess, mainstone-radian, mainstone-radiant, mainstone-round, mainstone-sq cushion, mainstone-square cushion, mainstone-square-cushion, sidestone-emerald, sidestone-marquise, sidestone-round, sidestone-round.001"
        }
    ];

    return three_d_media;
}
//#endregion

function initSimpleSlider(sliderSelector) {

    var slider = $(sliderSelector);
    if (!slider.length) return;

    var track = slider.find(".slider-track");
    var slides = slider.find(".slide");
    var prev = slider.find(".prev");
    var next = slider.find(".next");
    var dotsWrap = slider.find(".slider-dots");

    var index = 0;
    var total = slides.length;

    if (!total) return;

    dotsWrap.empty(); // reset dots (important for dynamic slides)

    // Create dots
    slides.each(function (i) {
        var dot = $("<button></button>");
        if (i === 0) dot.addClass("active");

        dot.on("click", function () {
            index = i;
            updateSlider();
        });

        dotsWrap.append(dot);
    });

    var dots = dotsWrap.find("button");

    function updateSlider() {
        track.css("transform", "translateX(-" + (index * 100) + "%)");

        dots.removeClass("active");
        dots.eq(index).addClass("active");
    }

    next.off("click").on("click", function () {
        index++;
        if (index >= total) index = 0;
        updateSlider();
    });

    prev.off("click").on("click", function () {
        index--;
        if (index < 0) index = total - 1;
        updateSlider();
    });

}